export default {"src":"/_next/static/media/request-features.9056535f.svg","height":32,"width":32};